import React, { Component } from "react";

export default class BreadcrumbFrontend extends Component {
  render() {
    return (
      <nav class="mt-3">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="/index.html">Home</a>
            </li>
            <li class="breadcrumb-item active">Details</li>
          </ol>
        </div>
      </nav>
    );
  }
}
